<template lang="pug">
.auto-renew-container()
  .auto-top-block()
  common-header.header(
    v-if="env.isEasyBikeApp"
    color='#242729',
    ref='header',
    title="自动续费管理",
    left-black-when-active,
    left-black-when-inactive
    :rightFlex="1"
    :left-balck-color="'https://m.hellobike.com/resource/helloyun/08345/RlDs2fAgvw.png?x-oss-process=image/quality,q_80'"
  )
  .auto-block(:style="env.isEasyBikeApp?'':'margin-top:-2.36rem'")
    .auto-top
      .auto-left
        .auto-img
          img.icon(src="https://m.hellobike.com/resource/helloyun/08345/LCox04uOFq.png")
        .auto-word
          .auto-top-word 你好，超级会员
          .auto-bottom-word 已开通自动续费
      .auto-right(@click="closeRenew") 关闭自动续费
    .auto-table
      .auto-item(v-for="(item,index) in tableList"
        :class="{'last-item': index === tableList.length - 1}")
        .auto-item-left {{item.label}}
        .auto-item-right {{item.value}}
  AutoRenewBlock(:show.sync="showDialog" :cancelSignDelay="cancelSignDelay")
</template>
<script>
import dayjs from 'dayjs';
import CommonHeader from '@/components/common-header';
import { env } from '@hb/hbridge';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { userVipSignInfoSearch } from '@/api/vip';
import { getTokenAndLocation } from '@/utils';
import AutoRenewBlock from './components/auto-renew-block.vue';

export default {
  components: {
    CommonHeader,
    AutoRenewBlock,
  },
  data() {
    return {
      env,
      showDialog: false,
      tableList: [{ label: '自动续费套餐', value: '' }, { label: '签约渠道', value: '' }, { label: '下次续费日期', value: '' }, { label: '下次续费金额', value: '' }],
      signChannelMap: {
        alipay: '支付宝',
        wechatTrust: '微信',
        douyinTrust: '抖音',
      },
      signChannel: '',
      propVersion: '',
      nextRenewalDate: '',
      nextRenewalAmount: '',
      propVersionMap: {
        normal: '超级会员',
        ladder: '畅享出行',
        ride: '随心骑',
        ride_app: '随心骑',
        ladder_app: '畅享出行',
        ride_trial: '随心骑',
        ride_ebike: '轻松骑',
        ride_ebike_app: '轻松骑',
        ladder_blend: '畅享出行',
        ladder_blend_two: '畅享出行',
        ride_ebike_fifteen: '轻松骑',
        ride_ebike_thirty: '轻松骑',
        ladder_discount_95_rate: '畅享出行',
      },
      cancelSignDelay: 500,
      isNew: null,
    };
  },
  created() {
    this.getData();
    UBT.pageView({
      pageId: 'platform_guanlixufei_page',
      categoryId: 'platform',
      businessInfo: {},
    });
    const { isNew } = this.$route.query;
    this.isNew = isNew;
  },
  mounted() {
    UBT.moduleExpose({
      pageId: 'platform_guanlixufei_page',
      categoryId: 'platform',
      moduleId: 'platform_guanbiziodngxufei',
      contentId: 'platform_guanbiziodngxufei',
      exposureTimes: 1,
      businessInfo: {},
    });
  },
  beforeDestroy() {
    UBT.pageViewOut({
      pageId: 'platform_guanlixufei_page',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    closeRenew() {
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_guanbiziodngxufei',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.showDialog = true;
      UBT.moduleExpose({
        pageId: 'platform_guanlixufei_page',
        categoryId: 'platform',
        moduleId: 'platform_zhijieguanbi',
        contentId: 'platform_zhijieguanbi',
        exposureTimes: 1,
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_guanlixufei_page',
        categoryId: 'platform',
        moduleId: 'platform_jixuxiangyong',
        contentId: 'platform_jixuxiangyong',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    async getData() {
      const { goodsGuid } = this.$route.query;
      const { token, cityCode } = await getTokenAndLocation();
      try {
        const res = await userVipSignInfoSearch({
          cityCode,
          token,
          appCode: 'platform',
          currentGoodsId: goodsGuid,
        });
        if (res.data) {
          this.cancelSignDelay = res.data.cancelSignDelay;
          this.nextRenewalAmount = res.data.nextRenewalAmount;
          this.nextRenewalDate = res.data.nextRenewalDate;
          this.propVersion = res.data.propVersion;
          this.signChannel = res.data.signChannel;
          this.tableList[0].value = this.propVersionMap[this.propVersion];
          this.tableList[1].value = this.signChannelMap[this.signChannel];
          this.tableList[2].value = dayjs(this.nextRenewalDate).format('YYYY-MM-DD');
          this.tableList[3].value = `¥${typeof (this.nextRenewalAmount) === 'number' ? this.nextRenewalAmount : ''}`;
        }
      // eslint-disable-next-line no-empty
      } catch {

      }
    },
  },
};
</script>
<style lang="less" scoped>
.auto-renew-container {
  background: #fff;

  .header {
    font-weight: 500;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  }

  .auto-top-block {
    width: 100%;
    height: 2.63rem;
    background: linear-gradient(180deg, #ffd575 0%, rgba(255, 233, 143, 0) 100%);
  }

  .auto-block {
    padding: 0 0.12rem;
    margin-top: -1.68rem;

    .auto-top {
      margin: 0 0.08rem 0.32rem 0.08rem;
      display: flex;
      justify-content: space-between;

      .auto-left {
        display: flex;

        .auto-img {
          img.icon {
            width: 0.42rem;
            height: 0.42rem;
          }
        }

        .auto-word {
          margin-left: 0.08rem;

          .auto-top-word {
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 500;
            font-size: 0.16rem;
            color: #441d06;
            line-height: 0.22rem;
          }

          .auto-bottom-word {
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 400;
            font-size: 0.12rem;
            color: #7c6050;
            line-height: 0.17rem;
            margin-top: 0.04rem;
          }
        }
      }

      .auto-right {
        margin-top: 0.04rem;
        width: 1.1rem;
        height: 0.34rem;
        background: #fff8e8;
        box-shadow: 0 0.01rem 0.02rem 0 #ffe9a9;
        border-radius: 0.17rem;
        border: 0.01rem solid #ffe1ab;
        text-align: center;
        line-height: 0.34rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        color: #441d06;
        text-shadow: 0 0.01rem 0.02rem 0 #ffe9a9;
      }
    }

    .auto-table {
      height: 2.13rem;
      background: #fff;
      box-shadow: 0 0.01rem 0.03rem 0 rgba(0, 0, 0, 0.04);
      border-radius: 0.16rem;

      .auto-item {
        height: 0.52rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.52rem;
        margin: 0 0.15rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        border-bottom: 0.005rem solid rgba(0, 0, 0, 0.06);

        .auto-item-left {
          color: #242729;
        }

        .auto-item-right {
          color: #879099;
        }
      }

      .last-item {
        height: 0.52rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.52rem;
        margin: 0 0.15rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        border-bottom: 0 solid rgba(0, 0, 0, 0.06);

        .auto-item-left {
          color: #242729;
        }

        .auto-item-right {
          color: #879099;
        }
      }
    }
  }
}
</style>
